// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kor-tab.tab li a[data-v-561ef106] {\n  padding: 0 33px;\n}\n", ""]);
// Exports
module.exports = exports;
